<template>
    <v-card
        :height="widgetHeight"
        :min-width="widgetWidth"
        class="ma-0 pa-0"
        :loading="loading"
        @mouseover.native="hover = true"
        @mouseleave.native="hover = false"
    >
        <v-card-title
            v-if="!loading"
            class="pa-0 ma-0"
            style="max-height: 40px !important"
        >
            <widget-header
                :title="
                    autorecognitionTrackerSettings.title ||
                    $t('WidgetAutorecognitionTrackerTitle')
                "
                :color="autorecognitionTrackerSettings.color || '#607d8b'"
                icon="mdi-brain"
            >
                <template slot="actions">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-icon
                                v-on="on"
                                class="mr-2"
                                @click.prevent="refresh"
                                >mdi-refresh</v-icon
                            >
                        </template>
                        <span>{{ $t('Refresh') }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="enableEdit">
                        <template v-slot:activator="{ on }">
                            <v-icon
                                v-on="on"
                                class="mr-2"
                                @click.prevent="editSettings"
                                >mdi-cog</v-icon
                            >
                        </template>
                        <span>{{ $t('Settings') }}</span>
                    </v-tooltip>
                    <v-tooltip top v-if="enableEdit">
                        <template v-slot:activator="{ on }">
                            <v-icon
                                v-on="on"
                                class="mr-2"
                                @click.prevent="removeWidget"
                                >mdi-delete</v-icon
                            >
                        </template>
                        <span>{{ $t('Delete') }}</span>
                    </v-tooltip>
                </template>
            </widget-header>
        </v-card-title>
        <v-card-text
            class="pa-3 ma-0 overflow-y-auto"
            :style="`height: ${contentHeight}px;max-height: ${contentHeight}px`"
        >
            <document-counter-component
                :refresh="refreshCounter"
                :autorecognitionTrackerSettings="autorecognitionTrackerSettings"
            ></document-counter-component>
            <SettingsModal :ref="settingsModalKey" @on-save="onSettingsSave" />
        </v-card-text>
    </v-card>
</template>

<script>
import SettingsModal from '@/components/widgets/autorecognition/WidgetAutorecognitionTrackerSettings';
import AutorecognitionTrackerSettings from '@/ecm/models/widget/autorecognitionTracker/AutorecognitionTrackerSettings';
import RecognitionStatus from '@/ecm/variables/RecognitionStatus.js';
import WidgetHeader from '@/components/widgets/WidgetHeader';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
import UserWidgetService from '@/services/UserWidgetService';
import DocumentCounterComponent from '@/components/aiRecognition/Components/DocumentCounterComponent.vue';
export default {
    name: 'WidgetAutorecognitionTracker',
    components: {
        SettingsModal,
        WidgetHeader,
        MiniStatistic,
        RecognitionStatus,
        DocumentCounterComponent,
    },
    props: {
        widgetId: {
            type: Number,
            default: 0,
        },
        id: {
            type: Number,
            default: 0,
        },
        enableEdit: {
            type: Boolean,
            default: false,
        },
        height: { type: Number, default: 0 },
        width: { type: Number, default: 0 },
        settings: { type: Object },
    },
    mounted() {
        this.widgetHeight = this.height;
        this.widgetWidth = this.width;

        this.autorecognitionTrackerSettings =
            new AutorecognitionTrackerSettings(this.settings);
        this.refresh();

        this.connection = $.hubConnection(this.apiUrl);
        this.connection.qs = { access_token: this.token };
        const notificationHub = this.connection.createHubProxy('notificationHub');
        const self = this;
        notificationHub.on('refresh', (notifications) => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(self.refresh, 5000);
        });
        this.connection.start();
    },
    destroyed() {
        if (this.connection) {
            this.connection.stop();
            this.connection = null;
        }
    },
    data() {
        return {
            connection: null,
            hover: false,
            headerHeight: 40,
            widgetHeight: 0,
            widgetWidth: 0,
            loading: false,
            settingsModalKey: 'modalSettingsKey',
            autorecognitionTrackerSettings:
                new AutorecognitionTrackerSettings(),
            refreshCounter: 0,
        };
    },
    computed: {
        modalSettings() {
            return this.$refs[this.settingsModalKey];
        },
        contentHeight() {
            return this.widgetHeight - this.headerHeight;
        },
    },
    methods: {
        resize(height, width) {
            this.widgetHeight = height;
            this.widgetWidth = width;
        },
        editSettings() {
            this.modalSettings.edit(this.autorecognitionTrackerSettings);
        },
        onSettingsSave(settings) {
            const widgetDto = {
                Id: this.id,
                WidgetID: this.widgetId,
                Settings: settings.toDto(),
            };
            const self = this;
            UserWidgetService.updateSettings(widgetDto).then((data) => {
                self.autorecognitionTrackerSettings = settings;
                self.refresh();
            });
        },
        removeWidget() {
            this.$emit('on-remove-widget', this.id);
        },
        refresh() {
            this.loading = true;
            this.refreshCounter = new Date().getTime();
            this.loading = false;
        },
    },
};
</script>
<style>
.pointer {
    cursor: pointer;
}
</style>
